<template>
  <div class="breadcrumbs">
    <div class="breadcrumbs-item">
      <div class="breadcrumbs-link">
        <div class="initial">EDD</div>
      </div>
    </div>
    <template v-for="item in breadcrumbs">
      <div :key="item.link" class="breadcrumbs-item">
        <div class="breadcrumbs-divider">/</div>
        <div class="breadcrumbs-link">
          <router-link :to="breadcrumbRoute(item)">{{ item.title }}</router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ComponentBreadcrumbs',

  computed: {
    breadcrumbs() {
      const multi = this.$route.meta.multiBreadcrumbs || false
      const items = this.$route.meta.breadcrumbs
      const user = this.$store.getters['profile/type']
      let list = items

      if (multi) {
        const type = items.hasOwnProperty(user) ? user : 'default'

        if (type === 'default') {
          list = items.default
        } else {
          list = items[type]
        }
      }

      return list
    }
  },

  methods: {
    breadcrumbRoute(item) {
      let link = { name: item.link }

      if (item.hasOwnProperty('params')) {
        const params = {}

        Object.entries(item.params).forEach((key, value) => {
          params[key] = this.$route.params[value]
        })

        link = { name: item.link, params }
      }

      return link
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  justify-content: center;

  a {
    color: $colour-light;

    &:hover {
      color: $colour-primary-alt;
      text-decoration: none;
    }
  }

  .breadcrumbs-item {
    display: flex;
    align-items: center;

    .breadcrumbs-link .initial {
      display: inline;
      padding: 2px 4px;
      background-color: $colour-light;
      color: $colour-secondary;
      font-weight: 500;
      cursor: default;
    }

    .breadcrumbs-divider {
      margin: -2px 4px 0;
    }
  }
}
</style>
